import { Separator } from '@components/ui/separator';

import type { AtomModel } from '@models/atom.model';

import type { TableEditorDateColumnData } from '@stratumn/studio-shared';
import { DateWidgetSettings } from '@widgets/date/date.widget.settings';

type Props = {
  atom: AtomModel<TableEditorDateColumnData>;
};

export const DateSettingsModal = ({ atom }: Props) => {
  // no specific settings for the date editor
  if (atom.data.isEditMode) {
    return null;
  }
  return (
    <>
      <DateWidgetSettings
        atomId={atom.id}
        deadlineWarningBuffer={atom.data.cell.view.deadlineWarningBuffer}
        doneVariableReference={atom.data.cell.view.doneVariableReference}
        isDeadline={atom.data.cell.view.isDeadline}
        onDeadlineWarningBufferChange={v =>
          (atom.data.cell.view.deadlineWarningBuffer = v)
        }
        onDoneVariableReferenceChange={v =>
          (atom.data.cell.view.doneVariableReference = v)
        }
        onIsDeadlineChange={v => (atom.data.cell.view.isDeadline = v)}
      />
      <Separator />
    </>
  );
};
